import { Component } from 'react';
import Header from '../../../Header';
import MessageLink from '../../../MessageLink';
import Footer from '../../../Footer';
import Lgpd from '../../../Lgpd';
import FiltroComunicados from '../../../Filtros/FiltroComunicados';
import ErrorBoundary from '../../../ErrorHandler/ErrorBoundary';
import InfoComponent from '../../InfoComponent';

class AtuarialA extends Component {

	render() {

		return (


			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>

				<InfoComponent image={"AtuarialA"} page={'AtuarialA'}></InfoComponent>		

				{/* <div className="_the-content page-noticias pt-10 mb-8"> */}
				<ErrorBoundary><FiltroComunicados url={"/ObterAtuarialPlanoA"} urlFiltro={"/ObterAtuarialPlanoA?"} /></ErrorBoundary>


				{/* Content page */}
				{/*  <ScrollInfinito/> */}
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default AtuarialA;